<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
    <Row :gutter="16">

      <Col span="12">
      <FormItem label="上传配偶身份证人像面" prop="idCardFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.idCardFrontGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.idCardFrontGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.idCardFrontGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传配偶身份证国徽面" prop="idCardBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.idCardBackGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.idCardBackGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.idCardBackGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="配偶姓名" prop="name">
        <Input v-model.trim="form.name" :maxlength="40" disabled placeholder=""></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="配偶身份证号" prop="idCardNo">
        <Input v-model.trim="form.idCardNo" :maxlength="40" disabled placeholder=""></Input>
      </FormItem>
      </Col>
      <Col span="24" v-if="form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']">
      <FormItem label="集体户口类型" prop="collectiveAccountMaterialsType">
        <RadioGroup v-model.trim="form.collectiveAccountMaterialsType">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.collectiveAccountMaterialsTypes" disabled :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <template
        v-if="form.registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">

        <Col span="12">
        <FormItem label="上传配偶户口簿详细地址页的首页" prop="residenceBookletMainPageGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">

              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.residenceBookletMainPageGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.residenceBookletMainPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.residenceBookletMainPageGuid)" type="ios-eye" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传配偶户口簿本人信息页" prop="residenceBookletSelfPageGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">

              <div class="fileList" v-if="form.residenceBookletSelfPageGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.residenceBookletSelfPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.residenceBookletSelfPageGuid)" type="ios-eye" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>
      <template v-if="form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
        <Col span="12">
        <FormItem label="派出所出具的户籍证明" prop="policeStationRegistrationCertificateGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.policeStationRegistrationCertificateGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.policeStationRegistrationCertificateGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.policeStationRegistrationCertificateGuid)" type="ios-eye" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>
      <Col span="12">
      <FormItem label="上传持证人结婚证原件" prop="marriageCertificateGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">

            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.marriageCertificateGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.marriageCertificateGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.marriageCertificateGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
    </Row>
  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },

  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {},
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //上一步
      let _this = this

      if (val < this.current) {
        this.$emit('next', val)
        return
      }
      //下一步

      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        let submiteUrl = '/api/services/app/JZZJFApi/SaveAppSpouseInfo'

        if (_this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'], submiteUrl)
          return
        }
        if (!this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['加分材料'], submiteUrl)
          return
        }
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'], submiteUrl)
          return
        }
      })
    },
    // submit(name) {
    //   let _this = this
    //   this.$refs[name].validate((valid) => {
    //     if (!valid) {
    //       this.$Message.error('请将信息填写完整')
    //       return
    //     }
    //     this.$Modal.confirm({
    //       title: '请确认',
    //       content: `<p>是否提交信息</p>`,
    //       okText: '是',
    //       cancelText: '否',
    //       onOk: () => {
    //         _this.$emit('submit')
    //       },
    //     })
    //   })
    // },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
  },
}
</script>